import {InvoiceComment, InvoiceDocument} from 'common'
import {InvoiceItemType} from 'common/apis/enums'
import {FirebaseInstances} from './helpers'
import {invoicesApi} from 'lib/api'

export function createInvoiceService(_fb: FirebaseInstances) {
  const sendNoticeOfRelease = async (invoice: InvoiceDocument) => {
    const invoiceId = invoice?.invoiceId
    if (!invoiceId) return {success: false}
    try {
      await invoicesApi.recordNoticeOfRelease(invoiceId)
      return {success: true}
    } catch (error) {
      return {error, success: false}
    }
  }

  const addLineItem = async ({
    amount,
    attachment,
    description,
    invoiceId,
    isCredit,
    quantity
  }: {
    invoiceId: string
    attachment: string
    amount: number
    description: string
    quantity: number
    isCredit: boolean
  }) => {
    try {
      const data = await invoicesApi.addLineItems(invoiceId, {
        amount,
        attachment,
        description,
        isCredit,
        quantity
      })
      return {data, status: true}
    } catch (error: any) {
      const {response} = error
      const {data, status} = response || {}
      return {message: data?.msg || data?.data || error, status, error}
    }
  }

  const removeInvoiceItem = async ({
    itemId,
    itemType,
    invoiceId
  }: {
    itemId: string
    invoiceId: string
    itemType: InvoiceItemType
  }) => {
    try {
      const response = await invoicesApi.removeInvoiceItem(invoiceId, {
        itemId,
        itemType
      })
      return {response, message: (response as any)?.msg, success: true}
    } catch (error: any) {
      const {response} = error
      const {data, status} = response || {}
      return {error: data?.msg || data?.data || error, errorCode: status}
    }
  }

  const markBuyerWireAsPaid = async ({
    wireConfirmationId,
    invoiceId
  }: {
    wireConfirmationId: string
    invoiceId: string
  }) => {
    try {
      const result = await invoicesApi.markBuyerWireAsPaid<{msg: string}>(
        invoiceId,
        {wireConfirmationId}
      )
      return {response: result, message: (result as any)?.msg, success: true}
    } catch (error: any) {
      const {response} = error
      const {data, status} = response || {}
      return {error: data?.msg || data?.data || error, errorCode: status}
    }
  }

  const addInvoiceComment = async ({
    invoiceId,
    invoiceComment
  }: {
    invoiceComment: InvoiceComment
    invoiceId: string
  }) => {
    try {
      await invoicesApi.addComment(invoiceId, {invoiceComment})
      return {success: true, message: 'Invoice comment added successfully.'}
    } catch (error) {
      return {
        success: false,
        message: 'Something went wrong! Failed to add invoice comment.'
      }
    }
  }

  return {
    sendNoticeOfRelease,
    addLineItem,
    removeInvoiceItem,
    markBuyerWireAsPaid,
    addInvoiceComment
  }
}
